<template>
  <div id="render_content">
    <VNode />
  </div>
</template>

<script setup lang="ts">
import { h } from 'vue';

const { $render } = useNuxtApp()

interface Props {
  data?: string
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  data: '',
  class: ''
})

const VNode = () => {
  if (props.data) {
    const data = JSON.parse(props.data)
    const html = $render.object(data)

    return html
  }

  return h('div', {
    class: props.class,
    innerHTML: `<div id="render_content"></div>`
  })
}
</script>


<style>
#render_content h1 {
  font-size: theme('fontSize.5xl');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content h2 {
  font-size: theme('fontSize.4xl');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content h3 {
  font-size: theme('fontSize.3xl');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content h4 {
  font-size: theme('fontSize.2xl');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content h5 {
  font-size: theme('fontSize.xl');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content h6 {
  font-size: theme('fontSize.lg');
  padding-bottom: theme('padding.2');
  font-weight: theme('fontWeight.bold');
}

#render_content p {
  padding-bottom: theme('padding.5')
}

#render_content ul {
  padding-left: theme('padding.4');
  list-style-type: theme('listStyleType.disc');
  padding-bottom: theme('padding.3')
}

#render_content .blockquote {
  margin-bottom: theme('margin.4');
  padding: theme('padding.4');
  background-color: theme('backgroundColor.primary.DEFAULT');
}

#render_content blockquote {
  font-size: theme('fontSize.xl');
  font-weight: theme('fontWeight.bold');
  padding-bottom: theme('padding.3');
  font-style: italic;
}

#render_content iframe {
  margin: theme('margin.4') auto;
}

#render_content li p {
  display: initial
}

#render_content table p {
  padding: 0;
}

</style>
